import { axiosInstance } from 'boot/axios';
import Message from 'src/models/message.js';
import { addMonths } from 'date-fns';
import { formatDate } from 'src/utils/format';

export function getMessages({ commit }) {
  commit('setIsLoadingMessages', true);
  return axiosInstance
    .get('Document/GetDocumentList')
    .then((response) => {
      commit(
        'setMessages',
        response.data.map((message) => new Message(message)),
      );
    })
    .finally(() => commit('clearIsLoadingMessages'));
}

export function getGenericDocuments({ commit }, payload) {
  commit('setIsLoadingGenericDocuments', true);
  return axiosInstance
    .get(`Document/GetGenericDocumentList?year=${payload}`)
    .then((response) => {
      if (response.status === 204) {
        commit('clearGenericDocuments');
      } else {
        commit(
          'setGenericDocuments',
          response.data.map((message) => new Message(message)),
        );
      }
    })
    .finally(() => commit('clearIsLoadingGenericDocuments'));
}

export function getUnreadDocumentCount({ commit }) {
  return axiosInstance.get('Document/GetUnreadDocumentCount').then((response) => {
    commit('setUnreadDocuments', response.data);
  });
}

export function getUnreadDocumentLast6MonthsCount({ commit }) {
  const sixMonthsAgo = formatDate(addMonths(new Date(), -6), 'yyyy-MM-dd');

  return axiosInstance.get(`Document/GetUnreadDocumentCount?dateOnly=${sixMonthsAgo}`).then((response) => {
    commit('setUnreadDocumentsLast6Months', response.data);
  });
}

export function setMessageToRead({ commit }, payload) {
  commit('setMessageToRead', payload);
}
